// import React, { useState } from "react";
// import Beams from "./Beams";
// import RahulImg from "../assets/Teampic/rahul.png";
// import ceo from "../assets/Teampic/Ceopic.png";
// import pdImg from "../assets/Teampic/padmanaban.png";

// // Import Poppins font in your index.html or CSS file:
// // <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@700&display=swap" rel="stylesheet">

// const team = [
//   {
//     name: "Raghvendra Bhagat",
//     role: "Chief Executive Officer",
//     image: ceo,
//     roleGroup: "CEO",
//     quote:
//       "At Starlabs, we don't just build products. We shape futures by combining bold vision with relentless execution.",
//   },
//   {
//     name: "Rahul Kushwaha",
//     role: "Product Lead",
//     image: RahulImg,
//     roleGroup: "Product Lead",
//     quote:
//       "Innovation is in our DNA. We challenge the status quo every day to bring cutting edge solutions to life.",
//   },
//   {
//     name: "Padmanaban V",
//     role: "Head of Growth",
//     image: pdImg,
//     roleGroup: "Head of Growth",
//     quote:
//       "Pixel perfect doesn't mean perfection. It means every interaction feels effortless and human.",
//   },
// ];

// const TeamSection = () => {
//   const [activeTab, setActiveTab] = useState("All");

//   const filteredTeam =
//     activeTab === "All"
//       ? team
//       : team.filter((member) => member.roleGroup === activeTab);

//   const tabs = ["All", "CEO", "Product Lead", "Head of Growth"];

//   return (
//     <section className="relative mx-auto text-white max-w-screen-2xl">
//       <div className="relative w-full h-[700px]">
//         {/* Overlay content */}
//         <div className="absolute top-0 left-0 z-20 w-full h-full text-white flex flex-col items-center justify-center px-4">
//           {/* Headings */}
//           <div className="mb-6">
//             <h1 className="text-4xl font-light text-center">
//               Meet the team that makes
//             </h1>
//             <h1 className="italic font-medium text-white text-4xl text-center">
//               the magic happen
//             </h1>
//           </div>

//           {/* Tabs */}
//           <div className="flex gap-3 justify-center mt-6 flex-wrap">
//             {tabs.map((tab) => (
//               <button
//                 key={tab}
//                 onClick={() => setActiveTab(tab)}
//                 className={`px-4 py-2 rounded-full text-sm font-medium shadow transition ${
//                   activeTab === tab
//                     ? "bg-white text-black"
//                     : "bg-white/20 text-white hover:bg-white/30"
//                 }`}
//               >
//                 {tab}
//               </button>
//             ))}
//           </div>

//           {/* Team Grid */}
//           <div
//             className={`mt-10 px-4 w-full max-w-5xl ${
//               activeTab === "All"
//                 ? "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6"
//                 : "flex justify-center"
//             }`}
//           >
//             {filteredTeam.map((member, index) => (
//               <div
//                 key={index}
//                 className="relative bg-black/40 backdrop-blur-sm rounded-2xl shadow-md flex flex-col items-center text-center"
//                 style={{
//                   background:
//                     "radial-gradient(125% 125% at 50% 10%, #000000 40%, #072607 100%)",
//                   width: activeTab === "All" ? "auto" : "300px", // Fixed width for single card
//                 }}
//               >
//                 <img
//                   src={member.image}
//                   alt={member.name}
//                   className="w-full h-60 object-contain"
//                 />
//                 <div
//                   className="w-[99%] rounded-2xl"
//                   style={{
//                     backgroundImage: `
//                       repeating-linear-gradient(0deg, rgba(255,255,255,0.04) 0, rgba(255,255,255,0.04) 1px, transparent 1px, transparent 40px),
//                       repeating-linear-gradient(45deg, rgba(0,255,128,0.09) 0, rgba(0,255,128,0.09) 1px, transparent 1px, transparent 20px),
//                       repeating-linear-gradient(-45deg, rgba(255,0,128,0.10) 0, rgba(255,0,128,0.10) 1px, transparent 1px, transparent 30px),
//                       repeating-linear-gradient(90deg, rgba(255,255,255,0.03) 0, rgba(255,255,255,0.03) 1px, transparent 1px, transparent 80px),
//                       radial-gradient(circle at 60% 40%, rgba(0,255,128,0.05) 0, transparent 60%)
//                     `,
//                     backgroundSize: "80px 80px, 40px 40px, 60px 60px, 80px 80px, 100% 100%",
//                     backgroundPosition: "0 0, 0 0, 0 0, 40px 40px, center",
//                     marginBottom: "5px",
//                     padding: "2px",
//                   }}
//                 >
//                   <h3 className="text-lg text-gray-200 font-semibold">
//                     {member.name}
//                   </h3>
//                   <p className="text-sm text-gray-200">{member.role}</p>
//                 </div>
//                 {/* Quote Display */}
//                 {activeTab !== "All" && (
//                   <div
//                     className="absolute top-1/2 -translate-y-1/2 left-[calc(100%+1rem)] w-64 text-left text-white text-xl italic font-bold quote"
//                     style={{
//                       background: "transparent",
//                       fontFamily: "'Poppins', sans-serif",
//                       fontWeight: 700,
//                     }}
//                   >
//                     {member.quote}
//                   </div>
//                 )}
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Beams Background */}
//         <Beams
//           beamWidth={2}
//           beamHeight={15}
//           beamNumber={12}
//           lightColor="#ffffff"
//           speed={2}
//           noiseIntensity={1.75}
//           scale={0.2}
//           rotation={0}
//         />
//       </div>
//     </section>
//   );
// };

// export default TeamSection;
//

import React, { useState } from "react";
import Beams from "./Beams";
import RahulImg from "../assets/Teampic/rahul.png";
import ceo from "../assets/Teampic/Ceopic.png";
import pdImg from "../assets/Teampic/padmanaban.png";

// Import Poppins font in your index.html or CSS file:
// <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@700&display=swap" rel="stylesheet">

const team = [
  {
    name: "Raghvendra Bhagat",
    role: "Chief Executive Officer",
    image: ceo,
    roleGroup: "CEO",
    quote:
      "At Starlabs, we don't just build products. We shape futures by combining bold vision with relentless execution.",
  },
  {
    name: "Rahul Kushwaha",
    role: "Product Lead",
    image: RahulImg,
    roleGroup: "Product Lead",
    quote:
      "Innovation is in our DNA. We challenge the status quo every day to bring cutting edge solutions to life.",
  },
  // {
  //   name: "Padmanaban V",
  //   role: "Head of Growth",
  //   image: pdImg,
  //   roleGroup: "Head of Growth",
  //   quote:
  //     "Pixel perfect doesn't mean perfection. It means every interaction feels effortless and human.",
  // },
];

const TeamSection = () => {
  const [activeTab, setActiveTab] = useState("CEO");

  // Filter based on activeTab, show all only for "All" tab
  const filteredTeam =
    activeTab === "All"
      ? team
      : team.filter((member) => member.roleGroup === activeTab);

  const tabs = ["All", "CEO", "Product Lead", "Head of Growth"];

  return (
    <section className="relative mx-auto text-white max-w-screen-2xl py-8">
      {/* Beams Background */}
      <div className="absolute inset-0 z-10">
        <Beams
          beamWidth={2}
          beamHeight={15}
          beamNumber={window.innerWidth < 640 ? 8 : 12} // Fewer beams on mobile
          lightColor="#ffffff"
          speed={2}
          noiseIntensity={1.75}
          scale={window.innerWidth < 640 ? 0.15 : 0.2} // Smaller scale on mobile
          rotation={0}
        />
      </div>
      <div className="relative w-full min-h-[600px] sm:min-h-[700px] z-20">
        {/* Overlay content */}
        <div className="absolute top-0 left-0 w-full h-full text-white flex flex-col items-center justify-center px-4 sm:px-6">
          {/* Headings */}
          <div className="mb-6">
            <h1 className="text-2xl sm:text-4xl font-light text-center">
              Meet the team that makes
            </h1>
            <h1 className="italic font-medium text-white text-2xl sm:text-4xl text-center">
              the magic happen
            </h1>
          </div>

          {/* Tabs */}
          <div className="flex gap-2 sm:gap-3 justify-center mt-6 flex-wrap">
            {tabs.map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`px-3 py-1 sm:px-4 sm:py-2 rounded-full text-xs sm:text-sm font-medium shadow transition ${
                  activeTab === tab
                    ? "bg-white text-black"
                    : "bg-white/20 text-white hover:bg-white/30"
                } ${tab === "All" ? "hidden sm:block" : ""}`}
              >
                {tab}
              </button>
            ))}
          </div>

          {/* Team Grid */}
          <div
            className={`mt-8 sm:mt-10 px-2 sm:px-4 w-full max-w-5xl ${
              activeTab === "All"
                ? "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6"
                : "grid grid-cols-1"
            }`}
          >
            {filteredTeam.map((member, index) => (
              <div
                key={index}
                className="relative bg-black/40 backdrop-blur-sm rounded-2xl shadow-md flex flex-col items-center text-center"
                style={{
                  background:
                    "radial-gradient(125% 125% at 50% 10%, #000000 40%, #072607 100%)",
                  width: "100%",
                  maxWidth: activeTab === "All" ? "300px" : "400px",
                }}
              >
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-48 sm:h-60 object-contain"
                />
                <div
                  className="w-[99%] rounded-2xl"
                  style={{
                    backgroundImage: `
                      repeating-linear-gradient(0deg, rgba(255,255,255,0.04) 0, rgba(255,255,255,0.04) 1px, transparent 1px, transparent 40px),
                      repeating-linear-gradient(45deg, rgba(0,255,128,0.09) 0, rgba(0,255,128,0.09) 1px, transparent 1px, transparent 20px),
                      repeating-linear-gradient(-45deg, rgba(255,0,128,0.10) 0, rgba(255,0,128,0.10) 1px, transparent 1px, transparent 30px),
                      repeating-linear-gradient(90deg, rgba(255,255,255,0.03) 0, rgba(255,255,255,0.03) 1px, transparent 1px, transparent 80px),
                      radial-gradient(circle at 60% 40%, rgba(0,255,128,0.05) 0, transparent 60%)
                    `,
                    backgroundSize:
                      "80px 80px, 40px 40px, 60px 60px, 80px 80px, 100% 100%",
                    backgroundPosition: "0 0, 0 0, 0 0, 40px 40px, center",
                    marginBottom: "5px",
                    padding: "2px",
                  }}
                >
                  <h3 className="text-base sm:text-lg text-gray-200 font-semibold">
                    {member.name}
                  </h3>
                  <p className="text-xs sm:text-sm text-gray-200">
                    {member.role}
                  </p>
                </div>
                {/* Quote Display */}
                {activeTab !== "All" && (
                  <div
                    className="w-full sm:w-64 text-center sm:text-left text-white text-base sm:text-xl italic font-bold quote mt-4 sm:mt-0 sm:absolute sm:top-1/2 sm:-translate-y-1/2 sm:left-[calc(100%+1rem)]"
                    style={{
                      background: "transparent",
                      fontFamily: "'Poppins', sans-serif",
                      fontWeight: 700,
                    }}
                  >
                    {member.quote}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
